export default __webpack_public_path__ + "imgs/bujue_logo.81303e63.png";